import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { GameIds } from '../../account/my-games/MyGames.model';
import { PromotionCard } from '../../account/promotion/PromotionCard';

import { useRedirectUrl } from '../../redirect-url/ProviderRedirectUrlContext';
import { ActivatePromotion } from '../Activation.model';

interface Props {
  gameId: GameIds;
  promotions: ActivatePromotion[];
}

export function ActivationNotConnected(props: Props): JSX.Element {
  const { t } = useTranslation();
  const { setRedirect } = useRedirectUrl();
  const history = useHistory();

  const goToSignin = (): void => {
    setRedirect(`${location.pathname}${location.search}`);
    history.push('/auth/signin');
  };

  return (
    <>
      <h2>
        {t('activation.title', {
          requiredGame: t(`games.${props.gameId}`),
          rewardGame: t(`games.${props.promotions[0]?.relatedToGameId}`),
        })}
      </h2>

      <div className='activation-content'>
        {props.promotions.map((promotion) => (
          <PromotionCard
            key={promotion.promotionId}
            activatePromotion={promotion}
          />
        )) }
      </div>

      <div className='activation-description'>
        <div className='question-circle-container activation-wizard'>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div className='question-circle disabled' data-content={t('activation.stepLogin')}>
                <div className='check' />
              </div>
              <div className='question-line disabled' />
            </div>
          </div>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div className='question-circle disabled' data-content={t('activation.stepActivation')}>
                <div className='check' />
              </div>
              <div className='question-line disabled' />
            </div>
          </div>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div className='question-circle disabled' data-content={t('activation.stepClaim')}>
                <div className='check' />
              </div>
            </div>
          </div>
        </div>

        <div className='content'>
          {t('activation.descriptionNotConnected')}
        </div>

        <button
          type='button'
          className='btn btn-primary-game'
          onClick={goToSignin}
          data-cy='activation-signin'
        >
          {t('button.sign-in')}
        </button>
      </div>
    </>
  );
}
